<template>
    <div class="tusd-wrap wrap-bg alipay">
        <div class="page-title">
            <i class="back-btn" @click="goBack"></i>
            添加固定收款方式
        </div>
        <div class="separator"></div>
        <div class="account-wrap">
            <div class="wrap-item">
                <span class="item-label">
                    支付宝账号：
                </span>
                <input type="text" v-model="account.BankAccount" placeholder="请输入支付宝账号" />
            </div>
			<div class="wrap-item">
				<span class="item-label">
					支付宝UID：
				</span>
				<input type="text" v-model="account.AlipayUid" placeholder="请输入支付宝UID" />
			</div>
            <div class="wrap-item">
                <span class="item-label">
                    收款方全称：
                </span>
                <input type="text" v-model="account.BankUser" placeholder="请输入收款方全称" />
            </div>
            <div class="wrap-item">
                <span class="item-label">分组管理：</span>
                <cube-select v-model="account.groupId" :options="bankGroupOptions"
                    @change="selectBankGroup"></cube-select>
            </div>
            <div class="wrap-item">
                <span class="item-label">收款方编号：</span>
                <input type="text" v-model="account.bankRemark" placeholder="请输入收款方编号" />
            </div>
            <div class="wrap-item">
				<span class="item-label">订单客户：</span>
				<div class="radio-wrap">
					<cube-radio-group
					@input="changePaymentCustomerLimit"
					v-model="optionCheckedValue.paymentCustomerLimitValue"
					:options="paymentCustomerLimitOptions"
					:horizontal="true"
					/>
			    </div>
			</div>
            <div class="wrap-item">
                <span class="item-label">固定金额：</span>
                <cube-select v-model="account.amountFixed" :options="fixedLimitOptions"
                    @change="handleSelect"></cube-select>
            </div>
            <div class="wrap-item item_top2">
                <span class="item-label">固定金额码：</span>
                <cube-upload class="header-wrap" ref="uploadFile" :max="10" :auto="false" :simultaneous-uploads="50"
                    @files-added="filesAdded">
                    <cube-upload-btn :multiple="true">
                        <div class="upload-btn2">
                            <i></i>
                        </div>
                    </cube-upload-btn>
                </cube-upload>
                <div class="img-name">
                    <p v-for="image in account.QRCodeUrls" :key="image.fileName">{{ image.originName }}</p>
                </div>
            </div>
            <div class="tusd-btn first-btn" @click="addAccount">确认添加</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'addFixedLimitQrcode',
    data() {
        return {
            account: {
                BankUser: "",
				AlipayUid: "",
                BankAccount: "",
                groupId: "",
                bankRemark: "",
                QRCodeUrls: [],
                paymentCustomerLimit:1
            },
            bankGroupOptions: [],
            params: {},
            fixedLimitOptions: [],
            optionCheckedValue: {
				paymentCustomerLimitValue:"正常",
			},
            paymentCustomerLimitOptions: ["全部","正常","新疆"],
			paymentCustomerLimitProp: [
				{
				label: "全部",
				value: 0
				},
				{
				label: "正常",
				value: 1
				}
				,
				{
				label: "新疆",
				value: 2
				}
			],
            //creditQrImgArray: []
        };
    },
    watch: {
        // "creditQrImgArray"(newVal, oldVal) {
        //     if (newVal) {
        //         this.filesSubmit(newVal)
        //     }
        // }
    },
    methods: {
        handleSelect(value, index, text) {
            this.account.amountFixed = value;
        },
        goBack() {
            this.$router.push({ name: this.params.back });
        },
        changePaymentCustomerLimit(v) {
		  this.account.paymentCustomerLimit = this.getProp(v, this.paymentCustomerLimitProp);
		},
        getProp(v, o, r) {
            let prop = '';
            o.map(i => {
                if (r) {
                    if (i.value == v) {
                        prop = i.label;
                    }
                } else {
                    if (i.label == v) {
                        prop = i.value;
                    }
                }
            });
            return prop;
        },
        selectBankGroup(value, index, text) {
            this.account.groupId = value;
        },
        getUserBankGroupList() {
            let that = this;
            this.$api.getUserBankGroups().then((res) => {
                res.data.filter((item) => item.PayType == 2).map(v => {
                    let temp = { text: v.Title, value: v.Id };
                    that.bankGroupOptions.push(temp)
                })
            });
        },
        getFixedSetting() {
            let that = this;
            this.$api.getFixedSetting().then((res) => {
                res.data.map(v => {
                    let temp = { text: v.AmountFixed, value: v.AmountFixed };
                    that.fixedLimitOptions.push(temp)
                })
                //console.log(that.fixedLimitOptions);
            });
        },
        addAccount() {
            let that = this;
			if (!that.account.BankAccount) {
				that.$message.popup("请输入支付宝账号", 1000);
				return false
			}
            if (!that.account.BankUser) {
				that.$message.popup("请输入收款方全称", 1000);
				return false
			}
			if (!that.account.groupId) {
				that.$message.popup("请选择分组管理", 1000);
				return false
			}
			if (!that.account.bankRemark) {
				that.$message.popup("请输入收款方编号", 1000);
				return false
			}
            if (that.account.QRCodeUrls.length == 0) {
                that.$message.popup("请至少上传一张定额收款码！", 1000);
                return false
            }

            that.$api.addFixedAlipay(that.account).then((res) => {
                that.$message.popup(res.msg, 1000);
                setTimeout(() => {
                    that.goBack();
                }, 1000);
            })
        },
        filesAdded(files) {
            if (!this.account.BankAccount) {
                this.$message.popup("请填写您的支付宝账号！", 1000);
                return;
            }
            let hasIgnore = false;
            const limitSize = 2 * 1024 * 1024;
            // 最大5M
            const maxSize = 5 * 1024 * 1024;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                // 如果选择的图片大小最大限制（这里为5M）则弹出提示
                if (file.size > maxSize) {
                    file.ignore = true;
                    hasIgnore = true;
                    break;
                }
                // 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
                let imageData;
                if (file.size > limitSize) {
                    this.compressPic(file);
                } else {
                    let reads = new FileReader();
                    reads.readAsDataURL(file);
                    let that = this;

                    reads.onload = function (e) {
                        var bdata = this.result;
                        file.base64 = bdata;
                        that.hasChange = true;
                        //that.creditQrImgArray.push(bdata);
                        imageData = bdata;

                        that.filesSubmit(bdata, file.name);
                    };
                }
            }
            hasIgnore && this.$message.popup("图片最大支持5M", 1000);
        },
        filesSubmit(imgData, fileName) {
            if (!this.account.BankAccount) {
                this.$message.popup("请填写您的支付宝账号！", 1000);
                return;
            }
            var data = {
                file: imgData,
                path: '/files/alipay/fixedamount/' + this.account.BankAccount + '/',
                fileName: fileName
            }
            console.log(data);
            this.$api.alipayImgListUpload(data).then((res) => {
                console.log(res.data);
                // this.$message.popup("上传成功", 1000);
                this.account.QRCodeUrls.push(res.data);
            })
        },
        // 图片压缩方法
        compressPic(file) {
            let reads = new FileReader();
            reads.readAsDataURL(file);
            // 注意这里this作用域的问题
            let that = this;
            let compressData;
            reads.onload = function (e) {
                var bdata = this.result;
                // 这里quality的范围是（0-1）
                var quality = 0.1;
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");
                var img = new Image();
                img.src = bdata;
                img.onload = function () {
                    var width = img.width;
                    canvas.width = width;
                    canvas.height = width * (img.height / img.width);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    let data = canvas.toDataURL("image/jpeg", quality);
                    file.base64 = data
                    that.hasChange = true;
                    that.filesSubmit(data, file.name);
                };
            };
        },
    },
    created() {
        this.params = this.$store.state.routerStore.addFixedLimitQrcode;
        if (!this.params.back) {
            this.params.back = 'accounts';
        }
        this.getUserBankGroupList();
        this.getFixedSetting();
    }
};
</script>
<style lang="less" scoped>
.img-name {
    color: #8092c6;
}

.header-wrap {
    display: inline-block;
    width: 80px;
    height: 80px;
    margin: 15px 0;

    .upload-btn {
        width: 100%;
        height: 100%;
        background: url(../assets/images/header.png) center center no-repeat;
        background-size: contain;
        border: 2px solid #cdcdcd;

        i {
            display: inline-block;
            vertical-align: middle;
            width: 75px;
            height: 80px;
            margin-right: 8px;
            background: url(../assets/images/upload.svg) center center no-repeat;
        }

    }

    .upload-btn2 {
        width: 100%;
        height: 100%;
        background-size: contain;
        border: 2px solid #cdcdcd;

        i {
            display: inline-block;
            vertical-align: middle;
            width: 75px;
            height: 80px;
            margin-right: 8px;
            background: url(../assets/images/upload.svg) center center no-repeat;
        }

    }

    .cube-upload-btn {
        height: 100%;
    }

}

.item_top {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
}

.item_top2 {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: wrap;
}
</style>
